const MapboxToken = 'pk.eyJ1IjoiYmFyZWFkdmVydGlzaW5nIiwiYSI6ImNsdnFydWNzYjA1ZXEya255djIwczhoZGQifQ.BhvUE3ISKWsIAOSFBqdccw';
export default MapboxToken;
